import NFA from './components/NFA';

export default NFA;